module.exports = __webpack_public_path__ + "static/media/066-chad.3e8fe8f7.svg";